export enum Sort {
  ASC_PRICE = 'Du - cher au + cher',
  DESC_PRICE = 'Du + cher au - cher',
  ASC_RATING = 'Note: par ordre croissant', // Unused
  DESC_RATING = 'Par meilleures notes',
  ASC_ALPHA = 'Nom: par ordre croissant', // Unused
  DESC_ALPHA = 'Nom: par ordre décroissant', // Unused
  DESC_DISTANCE = 'Du + loin au + proche', // Unused
  ASC_DISTANCE = 'Du + proche au + loin',
  DESC_TYPE = 'Type: par ordre décroissant',
  ASC_TYPE = 'Type: par ordre croissant',
}
